import {
  REQUEST_COVID_TRIALS_COUNTRY,
  RESPONSE_COVID_TRIALS_COUNTRY,
  FAILURE_COVID_TRIALS_COUNTRY
} from "../../../actions/types";

const initialState = {
  keyword: "",
  isFetching: false,
  statusCode: 0,
  results: [],
  error: false,
  isInitalScreen: true,
  total: 0,
  totalTrials: 0
};

const setFetching = (state, action) => {
  return {
    ...state,
    isFetching: true,
    statusCode: 0,
    results: [],
    keyword: action.payload.keyword,
    isInitalScreen: false,
    total: 0,
    totalTrials: 0
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: []
  };
};

const setResults = (state, action) => {
  let results = action.payload.results || [];
  let total = action.payload.total || 0;
  let totalTrials = action.payload.total_trials || 0;

  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    totalTrials,
    total
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_COVID_TRIALS_COUNTRY:
      return setFetching(state, action);
      break;

    case RESPONSE_COVID_TRIALS_COUNTRY:
      return setResults(state, action);

    case FAILURE_COVID_TRIALS_COUNTRY:
      return setFailure(state, action);

    default:
      return state;
      break;
  }
};
